export default __webpack_public_path__ + "static/media/c001-general2024-6.644fb550.png";